import React, { useRef } from 'react';
var VeltInlineCommentsSectionFilterDropdownContent = function (props) {
    var defaultCondition = props.defaultCondition, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-inline-comments-section-filter-dropdown-content", { ref: ref, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined }, children));
};
export default VeltInlineCommentsSectionFilterDropdownContent;
